import { useContext } from 'react';

import { LocomotiveScrollContext } from '../../context/locomotiveScroll/locomotiveScroll.context';
import { ILocomotiveScrollContext } from '../../context/locomotiveScroll/locomotiveScroll.types';

export const useLocomotiveScrollContext = (): ILocomotiveScrollContext =>
	useContext(LocomotiveScrollContext);
